.root {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 14px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.label {
  font-size: 11px;
  font-weight: 600;
  color: var(--rec-color-btn-dark);
}

.count {
  font-size: 10px;
  font-weight: 500;
  color: var(--rec-color-muted);
}

.track {
  display: flex;
  gap: 4px;
}

.segment {
  flex: 1;
  height: 6px;
  border-radius: 3px;
  background: var(--rec-color-border);
}

.segment-state-complete {
  background: #22c55e;
}

.segment-state-partial {
  background: var(--rec-color-warning-border);
}

.segment-state-missing {
  background: var(--rec-color-warning-border);
}
